import axios from 'axios'
import {host} from '../../configuraciones'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

const dataInicial = {
    vehiculos: [],
    coches:[]
}

//DEFINICIÓN DE MÉTODOS *********************************************************************************************
const OBTENER_DATOS_GET_VEHICULOS_EXITO= 'OBTENER_DATOS_GET_VEHICULOS_EXITO'
const INSERT_VEHICULO = 'INSERT_VEHICULO'
const UPDATE_VEHICULO = 'UPDATE_VEHICULO'
const DELETE_VEHICULO = 'DELETE_VEHICULO'
//*******************************************************************************************************************


//MÉTODOS 
export const getVehiculos = createAsyncThunk(
    OBTENER_DATOS_GET_VEHICULOS_EXITO,
    async () => {
        try {
            const fullUrl = host + `Automoviles/obtenerAutomoviles`
            const res = await axios.get(fullUrl)
            //console.log('Se obtienen los Vehiculos: '+JSON.stringify(res))
            return res
        } catch (error) {
            console.log(error);
        }
    }
)
export const getCoches = createAsyncThunk(
    OBTENER_DATOS_GET_VEHICULOS_EXITO,
    async () => {
        try {
            const fullUrl = host + `Automoviles/obtenerAutomoviles`
            const res = await axios.get(fullUrl)
            //console.log('Se obtienen los Coches: '+JSON.stringify(res))
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

export const insertVehiculo = createAsyncThunk(
    INSERT_VEHICULO,
    async (data) => {
        try {
            console.log(data)
            const fullUrl = host + `Automoviles/agregarAutomovil`
            const result = await axios.post(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

export const updateVehiculo = createAsyncThunk(
    UPDATE_VEHICULO,
    async (data) => {
        try {
            const fullUrl = host + `Automoviles/actualizarAutomovil`
            const result = await axios.put(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

export const eliminarVehiculo = createAsyncThunk(
    DELETE_VEHICULO,
    async (id) => {
        try {
            const fullUrl = host + `Automoviles/eliminarAutomovil/${id}`
            const result = await axios.delete(fullUrl)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

//****************************************************************************************************************
//EXPORTS DE MÉTODOS
export const metodosVehiculoSlice = createSlice({

    name: 'metodosVehiculoSlice',
    initialState: dataInicial,
    reducers: {
    },
    extraReducers: {
      
        [getVehiculos.fulfilled]: (state, { payload }) => {
            //console.log('PAYLOAD VEHICULOS'+JSON.stringify(payload))
            state.vehiculos = payload.data.data
            
        },
        [getCoches.fulfilled]: (state, { payload }) => {
            //console.log('PAYLOAD COCHES'+JSON.stringify(payload))
            state.coches = payload.data.data
        },
        [insertVehiculo.fulfilled]: (state, { payload }) => {

        },

        [updateVehiculo.fulfilled]: (state, { payload }) => {

        },
        [eliminarVehiculo.fulfilled]: (state, { payload }) => {

        },
       
    },

})


export const {} = metodosVehiculoSlice.actions
export const VehiculoReducer = metodosVehiculoSlice.reducer